import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { Button, Checkbox, Col, Input, Modal, Row, Table, Tooltip } from 'antd';
import Title from 'antd/es/typography/Title';
import { KeyResultSymbol, ObjectiveSymbol } from 'app/config/constants';
import ModalConfirmComponent from 'app/shared/component/modal/confirm';
import ModalRejectComponent from 'app/shared/component/modal/reject';
import * as _ from 'lodash';
import { checkPermission, completeProcess, getCurrentProcess, getEntitiesApprove, getOtherComment, rejectProcess, resetApprovalEntity, saveDraft } from './category-approve.reducer';
import OtherCommentComponent from './other-comment';
import { FuncTypes, funcTypeToString } from 'app/shared/model/enum/func-type.enum';
import AdjustObjectiveUpdate from 'app/entities/objective/form/objective-update-adjustment';
import CopyKR from 'app/entities/kr/form/copy/copy-kr';
import { log } from 'react-jhipster';
import { getApproveAdjustedYear, postAjustmentSubmission, previewAjustmentSubmission, saveDraftApproveAdjustedYear } from '../../approval-level.reducer';
import { getActiveYearPlanningWindow } from 'app/entities/annual-plan-window/annual-plan-window.reducer';
import { formatPercentTruncated } from 'app/shared/util/percent';

type IApproveObjectiveKRProps = {
    isOpen: boolean;
    onClose: (isReload?: boolean) => void;
    documentId: string;
    accountTableId: string;
    accountableName: string;
    itemsSelected: string;
};

const { Search } = Input;

export const ApproveAdjustedYearComponent = ({ isOpen, onClose, documentId, accountTableId, accountableName, itemsSelected }: IApproveObjectiveKRProps) => {
    const dispatch = useAppDispatch();
    const treeData = useAppSelector(state => state.categoryApprove.entityApproves);
    const loading = useAppSelector(state => state.categoryApprove.loading);
    const updating = useAppSelector(state => state.categoryApprove.updating);
    const account = useAppSelector(state => state.authentication.account);
    const otherComment = useAppSelector(state => state.categoryApprove.otherComment);
    const currentStatusProcessApprove = useAppSelector(state => state.categoryApprove.entity);
    const filters = useAppSelector(state => state.filters.objective);

    const [KRComments, setKRComments] = useState([])
    const [isOpenModalConfirmApprove, setOpenModalConfirmApprove] = useState(false);
    const [isOpenModalConfirmComplete, setOpenModalConfirmComplete] = useState(false);
    const [isOpenModalReject, setOpenModalReject] = useState(false);
    const [isUpdateSuccess, setUpdateSuccess] = useState(false);
    const [expandedRowKeys, setExpandedRowKeys] = useState([]);
    const [isLoadingComment, setLoadingComment] = useState(false);
    const [isOpenModalOtherComment, setOpenModalOtherComment] = useState(false);
    const [isOpenModalReportKr, setOpenModalReportKr] = useState(false);
    const [krBaseSelected, setKrBaseSelected] = useState(null);
    const [objSelected, setObjSelected] = useState(null);
    const [isOpenAdjustmentModel, setOpenAdjustmentModel] = useState(false);
    const [hasPermission, setPermission] = useState(null);
    const [selectedRows, setSelectedRows] = useState([]);
    const previewAjustmentSubmissiondata = useAppSelector(state => state.approvalLevel.previewAjustmentSubmission);
    const loadingPreviewAjustmentSubmission = useAppSelector(state => state.approvalLevel.loadingPreviewAjustmentSubmission);
    const approveAdjustedYear = useAppSelector(state => state.approvalLevel.approveAdjustedYear);
    const planningYear = useAppSelector(state => {
        const entity = state.yearPlanningWindow.entity;
        return entity?.year ?? (entity?.planYear != null ? Number(entity.planYear) : undefined);
    });


    useEffect(() => {
        dispatch(getActiveYearPlanningWindow());
        dispatch(getApproveAdjustedYear({
            ownerId: filters?.accountableId,
            userId: account?.id,
            planPeriodId: filters?.planPeriodId
        }))
    }, [])

    useEffect(() => {
        if (isUpdateSuccess)
            handleClose();
    }, [isUpdateSuccess])

    useEffect(() => {
        if (approveAdjustedYear.length > 0) {
            const allRowKeys = getAllRowKeys(approveAdjustedYear);
            setExpandedRowKeys(allRowKeys);
            setKRComments(getAllChildren(approveAdjustedYear).map(x => {
                return {
                    itemId: x?.itemId,
                    agree: x?.isAgree,
                    comment: x?.feedbackContent,
                }
            }))
        }
    }, [approveAdjustedYear])


    const getAllChildren = (nodes) => {
        let children = [];
        nodes.forEach(node => {
            children = children.concat(node.children); // Add the current node
        });
        return children;
    };

    const getAllRowKeys = (item) => {
        return item.reduce((keys, value, idx) => {
            keys.push(`${value?.itemId}`);

            if (value.children) {
                keys = keys.concat(getAllRowKeys(value.children));
            }

            return keys;
        }, []);
    };

    const columnConfig = [
        {
            title: '',
            dataIndex: 'itemCode',
            key: 'itemCode',
            width: 80,
            fixed: 'left' as const,
            align: 'center' as const
        },
        {
            title: 'KẾ HOẠCH ĐÃ PHÊ DUYỆT ĐẦU NĂM',
            children: [
                {
                    title: planningYear ? `Mục tiêu & KR ${planningYear}` : 'Mục tiêu & KR',
                    dataIndex: 'purposeYear',
                    key: 'purposeYear',
                    width: 250,
                    render: (text, record) => (
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            {record.children && record.children.length > 0 && (
                                <span
                                    style={{
                                        marginRight: 8,
                                        cursor: 'pointer',
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        width: '16px',
                                        height: '16px',
                                        border: '1px solid gray',
                                        minWidth: '16px',
                                        fontSize: '14px',
                                        lineHeight: 1,
                                        borderRadius: '4px',
                                        boxShadow: '0 0 0 1px white'
                                    }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        const newExpandedKeys = expandedRowKeys.includes(record.itemId)
                                            ? expandedRowKeys.filter(key => key !== record.itemId)
                                            : [...expandedRowKeys, record.itemId];
                                        setExpandedRowKeys(newExpandedKeys);
                                    }}
                                >
                                    {expandedRowKeys.includes(record.itemId) ? '−' : '+'}
                                </span>
                            )}
                            {text}
                        </div>
                    ),
                },
                {
                    title: 'Tỷ trọng',
                    dataIndex: 'contribution',
                    key: 'weight',
                    width: 100,
                    align: 'center' as const,
                    render: value => (value === undefined || value === null || value === '' ? '' : `${formatPercentTruncated(value)}%`),
                },
            ]
        },
        {
            title: 'KẾ HOẠCH ĐIỀU CHỈNH',
            children: [
                {
                    title: planningYear ? `Mục tiêu & KR ${planningYear}` : 'Mục tiêu & KR',
                    dataIndex: 'purposeYearByMidYear',
                    key: 'purposeYearByMidYear',
                    width: 250,
                },
                {
                    title: 'Tỷ trọng',
                    dataIndex: 'contributionByMidYear',
                    key: 'contributionByMidYear',
                    width: 100,
                    align: 'center' as const,
                    render: value => (value === undefined || value === null || value === '' ? '' : `${formatPercentTruncated(value)}%`),
                },
                {
                    title: 'KR Quý 3',
                    dataIndex: 'purposeQuarterThree',
                    key: 'purposeQuarterThree',
                    width: 150,
                },
                {
                    title: 'KR Quý 4',
                    dataIndex: 'purposeQuarterFour',
                    key: 'purposeQuarterFour',
                    width: 150,
                },
                {
                    title: 'Lý Do Điều Chỉnh Kế Hoạch',
                    dataIndex: 'reasonForAdjustment',
                    key: 'reasonForAdjustment',
                    width: 200,
                }
            ]
        },
        {
            title: "Ban ĐTPTDA - Nguyễn Văn A",
            children: [
                {
                    title: 'Đồng Ý',
                    dataIndex: 'agree',
                    key: 'agree',
                    width: 100,
                    align: 'center' as const,
                    render: (text, record) => (
                        !_.startsWith(record.itemCode, ObjectiveSymbol) && (
                            <Checkbox
                                checked={KRComments.find(x => x.itemId === record.itemId)?.agree}
                                onChange={(e) => handleChangeCheckBox(record.itemId, e.target.checked)}
                            />
                        )
                    )
                },
                {
                    title: 'Ý Kiến',
                    dataIndex: 'comment',
                    key: 'comment',
                    width: 100,
                    render: (text, record) => (
                        !_.startsWith(record.itemCode, ObjectiveSymbol) && (
                            <Input.TextArea
                                value={KRComments.find(x => x.itemId === record.itemId)?.comment}
                                onChange={(e) => handleChangeInput(record.itemId, e.target.value)}
                                autoSize={{ minRows: 1, maxRows: 3 }}
                            />
                        )
                    )
                }
            ]
        },

    ];

    const handleGetTreeOrg = () => {
        if (filters?.planPeriodId) {
            dispatch(getEntitiesApprove({
                ownerId: account?.id,
                accountTableId,
                planPeriodId: filters.planPeriodId
            }));
        }
    }


    const handleFreeTextSearchQuery = query => {
        // dispatch(setListFilterApprovalLevel({ ...filters, searchText: query }))
    };

    const handleClose = () => {
        dispatch(resetApprovalEntity())
        onClose(isUpdateSuccess);
    };

    const handleChangeCheckBox = (recordId, agree) => {
        setKRComments(prevState => {
            return prevState.map(item => {
                if (item.itemId === recordId) {
                    return { ...item, agree };
                }
                return item;
            });
        });
    }

    const handleChangeInput = (recordId, comment) => {
        setKRComments(prevState => {
            return prevState.map(item => {
                if (item.itemId === recordId) {
                    return { ...item, comment };
                }
                return item;
            });
        });
    }

    const mapData = () => {
        const payload = {
            userId: account?.id,
            ownerId: accountTableId,
            documentId: documentId,
            approveLevelId: approveAdjustedYear.length > 0 ? approveAdjustedYear[0]?.processingLevelId : undefined,
            year: planningYear,
            checkinFeedbackItems: KRComments.map(x => {
                return {
                    itemId: x.itemId,
                    isAgree: x.agree,
                    feedbackContent: x.comment
                }
            })
        }

        return payload;
    }

    const handleSaveDraft = () => {
        const payload = mapData()
        dispatch(saveDraftApproveAdjustedYear(payload))
    }

    const handleOpenModalConfirmApprove = () => {
        setOpenModalConfirmApprove(true);
    }

    const handleConfirmApprove = () => {
        setOpenModalConfirmApprove(true);
        handleApproveItemSelected()
    }

    const handleApproveItemSelected = () => {
        const payload = mapData()
        dispatch(completeProcess(payload)).then((res) => {
            if (res && res.payload)
                setUpdateSuccess(true)
        })
    }

    const handleOpenModalConfirmComplete = () => {
        setOpenModalConfirmComplete(true);
    }

    const handleConfirmComplete = () => {
        const payload = mapData()
        setOpenModalConfirmComplete(false);
        dispatch(completeProcess(payload)).then((res) => {
            if (res && res.payload)
                setUpdateSuccess(true)
        })
    }

    const handleOpenModalReject = () => {
        setOpenModalReject(true);
    }

    const handleReject = (reason: string) => {
        const payload = { ...mapData(), reason }
        setOpenModalReject(false);
        dispatch(rejectProcess(payload)).then((res) => {
            if (res && res.payload)
                setUpdateSuccess(true)
        })
    }

    const handleOpenModalOtherComment = () => {
        setOpenModalOtherComment(true);
    }

    const handleCloseModalOtherGeneralComment = () => {
        setOpenModalOtherComment(false);
    }

    const handleGetOtherComments = (value) => {
        setLoadingComment(true);
        handleOpenModalOtherComment()
        dispatch(getOtherComment({ itemId: value, ownerId: accountTableId })).finally(() => { setLoadingComment(false) });
    }

    const handleFinish = () => {
        handleOpenModalConfirmApprove()
    }

    const handleGetCurrentProcess = () => {
        dispatch(getCurrentProcess({ ownerId: accountTableId, userId: account?.id }));
    }

    const handleRowClick = (event, record) => {
        event.preventDefault();
        if (record?.itemId) {
            if (_.startsWith(record?.itemCode, KeyResultSymbol))
                handleOpenModalKr(record)
            else
                handleOpenModalAdjustmentObjective(record)
        }
    };

    const handleOpenModalKr = (dataKr = null) => {
        if (dataKr) {
            setKrBaseSelected({
                id: dataKr.itemId,
                planPeriodId: dataKr?.planPeriodId,
                objectiveId: dataKr?.objectiveId,
                krType: dataKr?.krType,
                planPeriodType: dataKr?.planPeriodType
            })
        }
        setOpenModalReportKr(true);
    };

    const handleCloseModalKr = reload => {
        setOpenModalReportKr(false);
        setKrBaseSelected(null)
        if (reload)
            handleGetTreeOrg();
    };

    const handleOpenModalAdjustmentObjective = (item) => {
        setObjSelected({
            id: item.itemId
        })
        setOpenAdjustmentModel(true);
    };

    const handleCloseModalAdjustmentObjective = reload => {
        setOpenAdjustmentModel(false);
        setObjSelected(null)
        if (reload)
            handleGetTreeOrg();
    };

    const handleCheckPermission = () => {
        dispatch(checkPermission({ ownerId: accountTableId, userId: account?.id })).then((res) => {
            if (res && res.payload) {
                const response = (res.payload as any).data
                setPermission(response.permission);
            }
        });
    }
    const handlePostAjustmentSubmission = () => {
        dispatch(postAjustmentSubmission({
            senderid: account?.id,
            ownerid: filters?.accountableId,
            planPeriodId: filters?.planPeriodId,
            itemIds: itemsSelected as any,
            year: planningYear,
        }))
    }

    return (
        <Modal open={isOpen} maskClosable={false} confirmLoading={loadingPreviewAjustmentSubmission} footer={null} onCancel={handleClose} width={'80vw'} className='view'>
            <div className="d-flex gap-5">
                <Title level={3}>{planningYear ? `Phê duyệt mục tiêu năm ${planningYear} điều chỉnh` : 'Phê duyệt mục tiêu năm điều chỉnh'} - {accountableName}</Title>
            </div>
            <div className="table">
                <div className="header">
                    <Col md={8}>
                        <Row className='w-100'>
                            <Col md={18}>
                                <Search size="large" allowClear placeholder="Nhập giá trị tìm kiếm" onSearch={handleFreeTextSearchQuery} enterButton />
                            </Col>
                        </Row>
                    </Col>
                    <Col md={13}>
                        <Row className='w-100 justify-content-end gap-2'>
                            <Button size="large" onClick={handleSaveDraft} disabled={updating || !planningYear} className="green">
                                Lưu nháp
                            </Button>
                            {(currentStatusProcessApprove.functionKey === FuncTypes.Check || currentStatusProcessApprove.functionKey === FuncTypes.Appraisal) &&
                                <Button size="large" onClick={handleOpenModalConfirmComplete} disabled={updating || !planningYear} className="green">
                                    {`Hoàn thành ${funcTypeToString(currentStatusProcessApprove.functionKey)}`}
                                </Button>
                            }
                            {currentStatusProcessApprove.functionKey === FuncTypes.Approve &&
                                <Button size="large" onClick={handleFinish} disabled={updating || !planningYear} className="green">
                                    Phê duyệt
                                </Button>
                            }
                            {currentStatusProcessApprove.functionKey !== FuncTypes.Appraisal &&
                                <Button size="large" onClick={handleOpenModalReject} disabled={updating || !planningYear} className="warning">
                                    Yêu cầu sửa lại
                                </Button>
                            }
                        </Row>
                    </Col>
                </div>
                <Table tableLayout='fixed' scroll={{ y: '60vh' }}
                    expandable={{
                        expandedRowKeys,
                        showExpandColumn: false,
                        onExpandedRowsChange(newExpandedRowKeys: any) {
                            setExpandedRowKeys(newExpandedRowKeys);
                        },
                    }}
                    rowClassName={(record, index) =>
                        _.startsWith(record.itemCode, ObjectiveSymbol) ? "fw-bold" : "" // Định nghĩa lớp CSS cho dòng lẻ
                    }
                    onRow={(record) => ({

                        onClick(event) {

                            const target = event.target as HTMLElement;
                            // Lấy danh sách tất cả các ô (td) trong hàng được nhấp
                            const cells = Array.from(event.currentTarget.querySelectorAll('td'));

                            // Xác định index của ô được nhấp
                            const clickedTd = target.closest('td'); // Tìm td gần nhất
                            if (!clickedTd) return; // Tránh lỗi nếu không tìm thấy td

                            const clickedIndex = cells.indexOf(clickedTd);

                            // // Danh sách index của các cột cần loại trừ
                            const excludedIndexes = [7, 8, 9];

                            if (!excludedIndexes.includes(clickedIndex)) {
                                handleRowClick(event, record);
                            }
                        },
                    })}
                    loading={loadingPreviewAjustmentSubmission || updating} bordered dataSource={(Array.isArray(approveAdjustedYear) ? approveAdjustedYear : []).map(x => ({
                        ...x,
                        key: x.itemId,
                        children: x.children?.map(y => ({ ...y, key: y.itemId }))
                    }))} pagination={false} columns={columnConfig} />
            </div>
            {isOpenModalReportKr &&
                <CopyKR
                    isOpen={isOpenModalReportKr}
                    isReadOnly={!hasPermission}
                    onClose={handleCloseModalKr}
                    krTypeRequest={krBaseSelected?.krType}
                    planPeriodType={krBaseSelected?.planPeriodType}
                    planPeriodIdSelected={krBaseSelected?.planPeriodId}
                    idKrBaseSelected={krBaseSelected?.id}
                    idObjective={krBaseSelected?.objectiveId} isEdit={true} />
            }
            {isOpenAdjustmentModel && (
                <AdjustObjectiveUpdate isOpen={isOpenAdjustmentModel} isReadOnly={!hasPermission} onClose={handleCloseModalAdjustmentObjective} id={objSelected?.id} />
            )}
            <ModalConfirmComponent
                visible={isOpenModalConfirmApprove}
                onCancel={() => {
                    setOpenModalConfirmApprove(false);
                }}
                onConfirm={handleConfirmApprove}
                isLoading={updating}
                title={`Bạn có chắc chắn muốn phê duyệt ?`}
            />
            <ModalConfirmComponent
                visible={isOpenModalConfirmComplete}
                onCancel={() => {
                    setOpenModalConfirmComplete(false);
                }}
                onConfirm={handleConfirmComplete}
                isLoading={updating}
                title={`Bạn đã hoàn thành kiểm tra dữ liệu ?`}
            />
            <ModalRejectComponent
                visible={isOpenModalReject}
                onCancel={() => {
                    setOpenModalReject(false);
                }}
                onReject={handleReject}
                isLoading={updating}
                title={`Yêu cầu sửa lại ?`} />
            {isOpenModalOtherComment &&
                <OtherCommentComponent
                    isLoading={isLoadingComment}
                    data={otherComment}
                    isOpen={isOpenModalOtherComment}
                    onClose={handleCloseModalOtherGeneralComment} />}
        </Modal>
    );
};

export default ApproveAdjustedYearComponent;
